// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__3oHbF","logo":"MainNavigation_logo__1lVgE","active":"MainNavigation_active__iCymT","badge":"MainNavigation_badge__3f5Uu"};